// extracted by mini-css-extract-plugin
export default {"card":"EmptyReportCard_card__FCl87","title":"EmptyReportCard_title__z-S+l","desc":"EmptyReportCard_desc__ckC06"};